import React from "react";
import { Flex, Heading, Text } from "theme-ui";
import { colors, typography } from "../../styles/theme";
import { graphql, useStaticQuery } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { PersonaSection } from "../molecules";
import { ActionBannerSectionHome, CustomerReviewHome, FeaturesSectionHome, HeroBannerHome } from "../homepage/shared";
import {
  EcosystemSection,
} from "./index";
import featuresData from "../../data/home/homeFeaturesSection.yml";

const Home = ({ data }) => {
  const {
    actionBannerImage,
    clientLogosIN,
    testimonials,
  } = useStaticQuery(graphql`
    query {
      actionBannerImage: file(
        relativePath: { eq: "homeV1/ActionBannerHomeIN.png" }
      ) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED)
        }
      }
      clientLogosIN: file(relativePath: { eq: "home/client-logos.png" }) {
        childImageSharp {
          gatsbyImageData(width: 1076, layout: CONSTRAINED)
        }
      }
      testimonials: allDatoCmsTestimonial(
        filter: {
          isActive: { eq: true }
          showInPages: { elemMatch: { code: { eq: "HOMEPAGE_V1" } } }
          employeeName: { eq: "Hiral Dave" }
        }
        limit: 1
      ) {
        nodes {
          feedback
          employeeName
          employeeDesignation
          testimonialImage {
            gatsbyImageData(
              layout: FIXED
              placeholder: BLURRED
              width: 401
              height: 486
            )
          }
          testimonialImageAltText
          slug
        }
      }
    }
  `);
  const bannerImage = getImage(actionBannerImage);
  const clientLogos = getImage(clientLogosIN);
  const testimonialImage = getImage(testimonials?.nodes?.[0]?.testimonialImage);

  return (
    <Flex sx={{ flexDirection: "column" }}>
      <HeroBannerHome data={data?.heroBanners[0]} code="IN"/>
      <FeaturesSectionHome
        heading={
          <Heading as="h2" sx={{ ...typography.h2, mb: "1.5rem" }}>
            Modern <Text sx={{ color: colors.primary700 }}>HR and Payroll</Text>{" "}
            are Complex
          </Heading>
        }
        subheading="greytHR solves some of the most common HR and Payroll issues that slow down your business."
        featuresData={featuresData}
        code="IN"
      />
      {data?.nodes && data?.personaSection?.[0] && (
        <PersonaSection
          personas={data.nodes}
          heading={data.personaSection[0]?.heading}
          description={data.personaSection[0]?.description}
        />
      )}
      <CustomerReviewHome
        clientLogos={clientLogos}
        testimonials={testimonials?.nodes}
        testimonialImage={testimonialImage}
        subheading="Depth of our features, ease of implementation and adoption, devoted
        after sales and support, cost-effectiveness - just a few things our
        30000+ customers love about us."
        testimonialTitle="greytHR is our go-to software..."
      />
      <EcosystemSection
        ecosystemSectionTitle={data?.ecosystemSectionTitle}
        ecosystemSectionImage={data?.ecosystemSectionImage}
        ecosystemSectionDescription={data?.ecosystemSectionDescription}
        ecosystems={data?.ecosystems}
      />
      <ActionBannerSectionHome
        image={bannerImage}
        imageAlt="India Home Page"
        title={
          <>
            Evaluating our pricing?
            <br />
            We’ll take the price challenge!
          </>
        }
        desc="Our customers endorse we offer exceptional software and service at unchallenged prices. Our costs per license are the lowest in our category."
        primaryBtnLabel="Plans and pricing"
        primaryBtnId="home_plans_and_pricing_in_btn"
        primaryBtnLink="/pricing/?gc_source=home"
        secondaryBtnLabel="Discuss pricing"
        secondaryBtnId="home_discuss_pricing_in_btn"
        secondaryBtnLink="/demo/?gc_source=home&ac_form_tag=AF_DEMO_HOME"
        testimonial="true"
        customStyles={{
          mb: 0,
        }}
      />
    </Flex>
  );
};

export default Home;
